// import React, { useState, useEffect } from "react";
// import { FaMicrophone, FaVolumeUp } from "react-icons/fa";

// const VoiceAssistant = () => {
//   const [active, setActive] = useState(false);
//   const [text, setText] = useState("");

//   const SpeechRecognition =
//     window.SpeechRecognition || window.webkitSpeechRecognition;

//   const recognition = SpeechRecognition ? new SpeechRecognition() : null;

//   useEffect(() => {
//     if (!recognition) return;

//     recognition.continuous = true;
//     recognition.interimResults = true;
//     recognition.lang = "en-IN";

//     recognition.onresult = (event) => {
//       let transcript = "";
//       for (let i = event.resultIndex; i < event.results.length; i++) {
//         transcript += event.results[i][0].transcript;
//       }
//       setText(transcript);
//     };

//     recognition.onend = () => setActive(false);
//   }, []);

//   const toggleAssistant = () => {
//     if (!recognition) {
//       alert("Speech Recognition not supported");
//       return;
//     }

//     if (active) {
//       recognition.stop();
//       setActive(false);
//     } else {
//       recognition.start();
//       setActive(true);
//       setText("");
//     }
//   };

//   return (
//     <>
//       <div
//         onClick={toggleAssistant}
//         style={{
//           position: "fixed",
//           bottom: "20px",
//           right: "20px",
//           width: "60px",
//           height: "60px",
//           borderRadius: "50%",
//           background: "#0d6efd",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           cursor: "pointer",
//           zIndex: 9999,
//           boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
//         }}
//       >
//         <FaVolumeUp color="#fff" size={22} />
//       </div>

//       {active && (
//         <div
//           onClick={toggleAssistant}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "rgba(0,0,0,0.2)", 
//             backdropFilter: "blur(2px)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             zIndex: 10000,
//           }}
//         >
//           <div style={{ position: "relative" }}>
//             <div style={pulse(1)}></div>
//             <div style={pulse(2)}></div>
//             <div style={pulse(3)}></div>

//             <div
//               style={{
//                 width: "90px",
//                 height: "90px",
//                 borderRadius: "50%",
//                 background: "#ff3b3b",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 zIndex: 2,
//                 position: "relative",
//               }}
//             >
//               <FaMicrophone size={30} color="#fff" />
//             </div>
//           </div>

//           <p
//             style={{
//               marginTop: "30px",
//               color: "#fff",
//               fontSize: "18px",
//               textAlign: "center",
//               maxWidth: "80%",
//             }}
//           >
//             {text || "Listening..."}
//           </p>
//         </div>
//       )}
//     </>
//   );
// };

// const pulse = (delay) => ({
//   position: "absolute",
//   width: "90px",
//   height: "90px",
//   borderRadius: "50%",
//   background: "rgba(255, 59, 59, 0.3)",
//   animation: `pulseAnim 1.8s ease-out ${delay * 0.4}s infinite`,
// });

// const styleSheet = document.styleSheets[0];
// const keyframes = `
// @keyframes pulseAnim {
//   0% {
//     transform: scale(1);
//     opacity: 0.6;
//   }
//   70% {
//     transform: scale(2.2);
//     opacity: 0;
//   }
//   100% {
//     opacity: 0;
//   }
// }
// `;
// styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

// export default VoiceAssistant;


import React, { useRef } from "react";

const VoiceAssistant = () => {
  const recognitionRef = useRef(null);

  const startListening = async () => {
    try {
      // 🔥 THIS LINE FORCES MIC POPUP
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  
      console.log("✅ Mic permission granted");
  
      // stop stream immediately (we just needed permission)
      stream.getTracks().forEach(track => track.stop());
  
    } catch (err) {
      console.error("❌ Mic blocked:", err);
      alert("Mic permission denied!");
      return;
    }
  
    // 👇 NOW start speech recognition
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
  
    if (!SpeechRecognition) {
      alert("SpeechRecognition not supported");
      return;
    }
  
    const recognition = new SpeechRecognition();
  
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = "en-US";
  
    recognition.onstart = () => {
      console.log("🎤 Mic started");
    };
  
    recognition.onresult = (event) => {
      let text = "";
  
      for (let i = event.resultIndex; i < event.results.length; i++) {
        text += event.results[i][0].transcript;
      }
  
      console.log("📝 You said:", text);
    };
  
    recognition.onerror = (e) => {
      console.log("❌ Error:", e.error);
    };
  
    recognition.start();
  };
  return (
    <div style={{ padding: "40px" }}>
      <h2>🎤 Voice Test</h2>

      <div
      onClick={startListening}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        background: "#0d6efd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 999999,
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
      }}
    >
      🎤
    </div>

      <p>👉 Click button → allow mic → speak → check console</p>
    </div>
  );
};

export default VoiceAssistant;